<template>
  <div class="nav-anchor w-100p bgc-fff l-0 z-98" :class="isFixed ? 'fixed' : 'sticky'">
    <div class="h-100p m-a d-f jc-sb ai-c fs-16 c-26">
      <strong class="d-f ai-c fs-20 fw-500">
        {{ productName }}
        <span class="d-n triangle-icon triangle-icon-fff bgs-cover bgp-c"></span>
      </strong>
      <div class="d-f">
        <div class="nav-anchor-item d-f jc-sb ai-c c-26">
          <a v-if="isShowOverview" :href="`${productUrl}#overview`">Overview </a>
          <a v-if="isShowFunction" :href="`${productUrl}#function`">Function</a>
          <a v-if="isShowFeatures" :href="`${productUrl}#features`">Features</a>
          <a v-if="isShowAccessories" :href="`${productUrl}#accessories`">Accessories</a>
          <a v-if="isShowResource" :href="`${productUrl}#resource`">Resource</a>
          <a v-if="specUrl" :href="specUrl">{{ specTitle }}</a>
        </div>
        <div v-if="$slots.rigthbtn">
          <slot name="rigthbtn" />
        </div>
        <nuxt-link v-else class="dealer-free-quote-btn d-ib ta-c bgc-222 c-fff in-pc" to="/basicinfo" target="_blank"
          >Free Quote</nuxt-link
        >
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      isFixed: {
        tyep: String,
        default: false
      },
      specUrl: {
        type: String,
        default: ''
      },
      productUrl: {
        type: String,
        default: ''
      },
      specTitle: {
        type: String,
        default: 'SPECs'
      },
      navAnchorData: {
        type: Object,
        default: () => {}
      },
      // 产品名等信息需要都传入 国际化名字
      productName: {
        type: String,
        default: ''
      },
      productSpecUrl: {
        type: String,
        default: ''
      },
      isShowOverview: {
        type: Boolean,
        default: true
      },
      isShowFeatures: {
        type: Boolean,
        default: true
      },
      isShowAccessories: {
        type: Boolean,
        default: false
      },
      isShowResource: {
        type: Boolean,
        default: false
      },
      isShowFunction: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {}
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  /* nav-anchor */
  .nav-anchor {
    height: 0.56rem;
    top: 0.76rem;
    box-shadow: 0px 0.02rem 0.04rem 0px rgba(0, 0, 0, 0.1);
  }
  .nav-anchor.fixed {
    position: fixed;
  }
  .nav-anchor.sticky {
    position: sticky;
  }
  .nav-anchor > div {
    padding-left: 1.6rem;
    padding-right: 1.6rem;
  }
  .nav-anchor a {
    margin-left: 0.8rem;
  }
  .nav-anchor .nav-anchor-item a:hover {
    font-weight: 700;
  }
  .nav-anchor .dealer-free-quote-btn {
    width: 1.2rem;
    line-height: 0.32rem;
    transition: background-color 0.3s linear;
  }
  .nav-anchor .dealer-free-quote-btn:hover {
    color: #fff;
    background-color: rgba(34, 34, 34, 0.85);
  }
</style>
